import { useCallback } from 'react';
import { useHref } from 'react-router-dom';
import { createHref } from 'utils/routing';

/**
 * Helper to create URLs with the correct account ID basename (i.e. /settings -> /4301/settings).
 */
export const useCreateHref = () => {
  const basename = useHref('/');

  return useCallback(
    (pathname: string) => {
      return createHref(pathname, basename);
    },
    [basename]
  );
};
